import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="errors"
export default class extends Controller {
  connect() {
    let type = this.element.dataset.flashType;
    let message = this.element.innerHTML;

    toastr[type](message, '', toastOptions)
    document.querySelector('#errors-container').innerHTML = "";
  }
}